import { IconTimesFilled } from '@iwoca/icons';
import { Spinner } from '@iwoca/orion';

import { SearchResult } from './deriveResultRows';
import { SearchResultRow } from './SearchResultRow';
import { CustomerRow } from '../../CustomersV2.types';

export const SearchResultsOverlay = ({
  results,
  loading,
  term,
  onNavigate,
  onDeclinedClick,
}: {
  results: SearchResult[];
  loading: boolean;
  term: string;
  onNavigate: () => void;
  onDeclinedClick: (row: CustomerRow) => void;
}) => {
  return (
    <div className="absolute left-0 right-0 top-full z-10 mt-s flex flex-col overflow-hidden rounded-s border border-secondary-80 bg-structure-100 shadow-blue-s">
      {loading ? (
        <div className="flex justify-center py-l">
          <Spinner />
        </div>
      ) : results.length === 0 ? (
        <div className="flex items-center justify-between bg-structure-100 p-r">
          <span className="flex-1 text-s font-med text-structure-40">
            No customers match your search
          </span>
          <span className="inline-flex shrink-0 items-center gap-s rounded-2xl bg-structure-95 px-s py-[6px] text-xs font-med text-structure-40">
            <IconTimesFilled className="size-l shrink-0" />
            No results
          </span>
        </div>
      ) : (
        <div className="flex max-h-[240px] flex-col overflow-y-auto">
          {results.map(({ row, tab }) => (
            <SearchResultRow
              key={row.buyer_state_key}
              row={row}
              tab={tab}
              term={term}
              onNavigate={onNavigate}
              onDeclinedClick={onDeclinedClick}
            />
          ))}
        </div>
      )}
    </div>
  );
};
